
import { defineComponent, computed, inject, ref, provide, watch } from 'vue'
import { AuthPlugin } from '@/auth'
import { useRoute, useRouter } from 'vue-router'
import ja from 'element-plus/es/locale/lang/ja'
import BaseFooter from '@/components/BaseFooter.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'

export default defineComponent({
  name: 'App',
  components: {
    BaseFooter,
    ImpersonationBanner
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const currentMenuIndex = ref('1')
    const idTokenClaims = ref()

    const auth: AuthPlugin | undefined = inject('Auth')
    if (!auth) {
      throw new Error('Auth plugin is not provided')
    }

    const handleMenuSelect = (key: string) => {
      if (key === '1') {
        router.push('/')
      } else if (key === 'failed-videos') {
        router.push('/failed-videos')
      } else if (key === '2') {
        router.push('/list')
      } else if (key === '3') {
        router.push('/setting')
      } else if (key === '4') {
        auth.logout({ returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI })
      }
    }

    const getIdToken = async () => {
      idTokenClaims.value = await auth.getIdTokenClaims({})
      console.log(idTokenClaims)
    }

    const getCustomRoles = () => {
      if (!idTokenClaims.value) return []
      return idTokenClaims.value[`${process.env.VUE_APP_AUTH0_CLAIMS_NAMESPACE}/roles`] || []
    }

    const isAdminUser = computed(() => getCustomRoles().includes('aimeat-admin'))

    const isFarmerUser = computed(() => getCustomRoles().includes('aimeat-farmer'))

    // ルートが変更されたときにメニュー選択を更新
    watch(
      () => route.path,
      (path) => {
        if (isFarmerUser.value && (path === '/' || path === '/setting' || path === '/failed-videos')) {
          router.replace('/list')
          return
        }
        if (path === '/') currentMenuIndex.value = '1'
        else if (path === '/failed-videos') currentMenuIndex.value = 'failed-videos'
        else if (path === '/list') currentMenuIndex.value = '2'
        else if (path === '/setting') currentMenuIndex.value = '3'
        else currentMenuIndex.value = ''
      },
      { immediate: true }
    )

    watch(isFarmerUser, (farmer) => {
      if (farmer && (route.path === '/' || route.path === '/setting' || route.path === '/failed-videos')) {
        router.replace('/list')
      }
    })

    ;(async () => {
      await getIdToken()
    })()

    provide('IsAdminUser', isAdminUser)
    provide('IsFarmerUser', isFarmerUser)

    const locale = ja

    return {
      auth,
      isAdminUser,
      isFarmerUser,
      handleMenuSelect,
      currentMenuIndex,
      locale,
    }
  },
})
